import React from 'react';
import { useSelector } from 'react-redux';

/**
 * Use Asset-type (Alt-asset) Resolution Reasons Hook
 */
export default (typeId: number) => {
  const { typesList } = useSelector((state) => state);

  const next = React.useMemo(() => {
    if (typeId) {
      const { altAssetResolutionAssetTypes, altAssetResolutionTypes } = typesList;
      const resolutionReasonIds = altAssetResolutionAssetTypes.data
        .filter((item) => item.assetTypeId === typeId)
        .map((item) => item.resolutionReasonId)
      ;
      return altAssetResolutionTypes.data.filter(({ id }) => (
        resolutionReasonIds.includes(id)
      ));
    }
    return [];
  }, [typeId, typesList]);

  return next;
};
